import { useTheme } from '../../../../../hooks/theme.hook'
import { Cluster } from '../types'
import { Pressable } from 'react-native'
import { Text, Icon } from 'react-native-paper'
import { ContributionsTypesCount } from './contribution-types.count'
import { createStyle } from '../../../../../contexts/global-styles.provider'
import { Article, ContributionType } from '../../../../../generated/graphql'
import { CorankTag } from '../../../../../@ui/buttons/corank.button'
import { Row } from '../../../../../@ui/containers/grid/row'
import { IconGoTo } from '../../../../../utils/meldd-icons'
import Column from '../../../../../@ui/containers/grid/column'
import {
  VoteButton,
  VoteButtonCluster,
  type VoteChangePayload,
} from '../vote/vote.button'

interface PerspectiveTileProps {
  cluster: Cluster
  perspective: Article
  onPress: () => void
  onVoteChange?: (payload: VoteChangePayload) => void
  readonly?: boolean
  navigateToContributions: (contributionType: ContributionType) => void
}

export function PerspectiveTile(props: PerspectiveTileProps) {
  const theme = useTheme()

  const { perspective, cluster: clusterData } = props
  const styles = useStyle()
  return (
    <Pressable onPress={props.onPress} style={styles.container}>
      <Column columnGap={2}>
        <Row columnGap={8}>
          <Row flex={1} wrap={true}>
            <Text
              selectable={false}
              numberOfLines={3}
              style={{ marginRight: 12, textDecorationLine: 'underline' }}
            >
              {perspective.title}
              {'...'}
            </Text>
          </Row>
          <Column width="auto" alignItems="center">
            <Icon source={IconGoTo} size={16} />
          </Column>
        </Row>
        <Row
          flex={1}
          wrap={true}
          justifyContent="space-between"
          alignItems="center"
        >
          <Row alignItems="center">
            <CorankTag size={18} corank={perspective.minCoRank} />
            <ContributionsTypesCount
              navigateToContributions={(contributionType) =>
                props.navigateToContributions?.(contributionType)
              }
              perspectiveId={perspective.id}
              contributions={perspective.contributions || []}
            />
          </Row>
          <VoteButton
            cluster={clusterData as unknown as VoteButtonCluster}
            readonly={props.readonly}
            style={styles.vote}
            perspective={perspective}
            onVoteChange={props.onVoteChange}
          />
        </Row>
      </Column>
    </Pressable>
  )
}

const useStyle = createStyle(({ theme }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: theme.spacing(3),
    padding: theme.spacing(4),
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.surfaceVariant,
  },
  icon: {
    flex: 0,
    flexBasis: 'auto',
  },

  vote: {
    flex: 0,
    flexBasis: 'auto',
    backgroundColor: theme.colors.background,
  },
}))
